import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { TableColumnDef } from "../../components/DataTable";
import { createSanitizedMarkup } from "../../utils/createSanitizedMarkup";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

type ColumnActions = {
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  lang: ContentLanguage;
};

export const buildWreathCardColumns = ({
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  lang,
}: ColumnActions): TableColumnDef[] => [
  {
    header: "Name",
    render: (row: any) => (lang === "de" ? row?.name_ger : row?.name) || "-",
    getValue: (row: any) => lang === "de" ? row?.name_ger : row?.name,
  },
  {
    header: "Information",
    render: (row: any) => {
      const html = lang === "de" ? row?.information_ger : row?.information;
      return typeof html === "string" ? (
        <div
          className="showmore-class"
          style={{ padding: "8px" }}
          dangerouslySetInnerHTML={createSanitizedMarkup({ html })}
        />
      ) : (
        <span>-</span>
      );
    },
  },
  {
    header: "Prozentsatz",
    render: (row: any) =>
      row?.percentage === "0" || row?.percentage === null
        ? row?.amount + "\u20AC"
        : row?.percentage + "%",
    getValue: (row: any) => Number(row?.percentage) || Number(row?.amount) || 0,
  },
  {
    header: "Einstellungen",
    render: (row: any) => (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {canEdit && (
          <Tooltip title="Bearbeiten" arrow>
            <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
              <CreateIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title="L&ouml;schen" arrow>
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
